import { render, staticRenderFns } from "./AdvancedRadioGroupWithDescription.vue?vue&type=template&id=4edaf30e"
import script from "./AdvancedRadioGroupWithDescription.vue?vue&type=script&lang=ts"
export * from "./AdvancedRadioGroupWithDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports